import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '@env/environment';
import { LoggerService } from '@app/logger/logger.service';

const log = new LoggerService('LEGACY UPLOAD SERVICE');

/**
 * Subida de archivos contra `POST {API_URL}/uploadPDF` (multipart con FormData).
 *
 * Es el contrato del backend de Medtronic. `UploadDownloadService` (portado de
 * Biomédica) habla con otro endpoint y devuelve URLs prefirmadas, así que los
 * dos conviven: los módulos nuevos usan aquel, y los de Medtronic este.
 *
 * No se fija Content-Type a mano: el navegador debe poner el boundary del
 * multipart. El Bearer lo adjunta el authInterceptor.
 */
@Injectable({ providedIn: 'root' })
export class LegacyUploadService {
  private http = inject(HttpClient);

  public async upload(data: FormData | any): Promise<Utils.ApiResponse<any>> {
    const url = `${environment.API_URL}/uploadPDF`;

    if (data instanceof FormData) {
      const entries: any = {};
      data.forEach((value, key) => {
        entries[key] = value instanceof File ? `File: ${value.name} (${value.size} bytes)` : value;
      });
      log.debug('[upload] FormData contenido:', entries);
    }

    try {
      const apiResponse = await firstValueFrom(this.http.post<Utils.ApiResponse<any>>(url, data));
      log.debug('[upload] API Response:', {
        state: apiResponse?.state,
        message: apiResponse?.message,
        dataIsArray: Array.isArray(apiResponse?.data),
      });
      return apiResponse;
    } catch (error) {
      log.error('[upload] Error en la petición:', error);
      throw error;
    }
  }
}
